// Check for missing env vars
let errorMsg = '';

const env = {
  REACT_APP_CLLCTVE_API_ORIGIN: processVar('REACT_APP_CLLCTVE_API_ORIGIN'),
  NODE_ENV: processVar('NODE_ENV'),
  // Firebase config
  REACT_APP_FIREBASE_API_KEY: processVar('REACT_APP_FIREBASE_API_KEY'),
  REACT_APP_FIREBASE_AUTH_DOMAIN: processVar('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  REACT_APP_FIREBASE_PROJECT_ID: processVar('REACT_APP_FIREBASE_PROJECT_ID'),
  REACT_APP_FIREBASE_STORAGE_BUCKET: processVar('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID: processVar('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  REACT_APP_FIREBASE_APP_ID: processVar('REACT_APP_FIREBASE_APP_ID'),
  REACT_APP_FIREBASE_MEASUREMENT_ID: processVar('REACT_APP_FIREBASE_MEASUREMENT_ID'),
};

function processVar(key) {
  if (!process.env[key]) {
    console.log(`WARNING: ${key} is undefined`);
    errorMsg += `${key}\n`;
    return '';
  }
  return process.env[key];
}

// if (errorMsg) throw new Error(`Required env vars missing: \n${errorMsg}`);

export default env;
